
  import {
    Component,
    Vue,
    Watch
  } from "vue-property-decorator";
  import CollapseItem from '@/components/collapse.vue';
  import PageFooter from '@/components/page-footer.vue';
  import {
    grade, imgHost
  } from '@/utils/config';
  import {
    getAgentUserDetail,
    setAgentCheckUserInfo,
    getAgentUserList,
  } from '@/api/agent_user'
  import UploadImg from '@/components/upload-img.vue';
  import {
    getOssToken
  } from '@/api/user'

  @Component({
    name: 'member-info',
    components: {
      CollapseItem,
      PageFooter,
      UploadImg
    }
  })
  export default class MemberInfo extends Vue {
    private type = this.$route.query.type;
    private id = +this.$route.query.id || 0;
    private imgUrl = imgHost;
    private levelName = grade
    private chooseTab = 0;
    private gradeList = [{
        label: 'VIP',
        value: 3,
        disabled: false
      }, {
        label: 'VIC',
        value: 2,
        disabled: false
      }, {
        label: 'SVIC',
        value: 1,
        disabled: false
      }
    ];
    private gradeType = 3;
    private userStatus = 0;
    private token = {}; // 上传token
    private statusList: any = [{
        label: '待审核',
        value: 1,
      }, {
        label: '已审核',
        value: 2,
      }, {
        label: '已拉黑',
        value: -1,
      }
    ]
    private paperType = 0;
    private papers: any = [{
      label: '居民身份证',
      value: 0
    }]
    private invite_id: any = ''
    @Watch('invite_id')
    private oninvite_id(val: any, old: any) {
      if(+val === this.id){
        this.$message({
          type: 'warning',
          message: '推荐人不能设置自己'
        })
        this.invite_id = old
      }
    }
    private formData: any = {
      Name: '', // (string, optional): 姓名,
      WxHeadUrl: '', // (string, optional): 微信头像,
      Phone: '', // (string, optional): 手机号,
      WeixinId: '', // (string, optional): 微信号,
      RoleGrade: '', // (int): 代理等级,
      RoleGradeValue: '', // (string, optional),
      Super: '', // (string, optional): 上级,
      Recommend: '', // (string, optional): 推荐人,
      RecommendId: '', // (int): 推荐人,
      AuthState: '', // (int): 用户状态,
      AuthStateValue: '', // (string, optional),
      IdCardNo: '', // (string, optional): 身份证号,
      CardIdFrontImgUrl: '', // (string, optional): 身份证正面,
      CardIdFrontImgUrlComplete: '', // (string, optional),
      CardIdBackImgUrl: '', // (string, optional): 身份证反面,
      CardIdBackImgUrlComplete: '', // (string, optional)
    }
    private loadingProduct = false;
    private members = []

    private mounted() {
      if (this.id) {
        this.getDetail()
      }
      // this.getToken()
    }

    private toBack() {
      this.$router.go(-1)
    }

    // 获取token
    private async getToken() {
      try {
        const res: any = await getOssToken({})
        this.token = {
          AccessKeySecret: res.access_key_secret,
          OSSAccessKeyId: res.access_key_id,
          SecurityToken: res.security_token
        }
      } catch (e) {
        console.log('getOssToken ===>', e)
      }
    }

    // 获取详情
    private async getDetail() {
      try {
        const res: any = await getAgentUserDetail({
          MemberId: this.id,
        })
        // res.Result.RoleGrade = 3;
        this.formData = res.Result;
        // console.log(this.formData)
        // this.invite_id = res.info.invite_info.user_id;
        // this.members = [res.info.invite_info]
        this.gradeList.map((item: any) => {
          if ([0, 1].indexOf(Math.abs(item.value - this.formData.RoleGrade)) !== -1) {
            item.disabled = false;
          } else {
            item.disabled = true;
          }
        })
        // console.log(this.gradeList)
      } catch (e) {
        console.log(e)
      }
    }

    /**
     * 监听输入框
     */
    private handleInput(type: string) {
      console.log(type)
    }

    // 提交信息
    private submit() {
        this.doUpdate();
    }

    // 创建
    private async doCreate() {
      try {
        console.log(this.formData)
      } catch (e) {
        console.log(e)
      }
    }

    // 更新
    private async doUpdate() {
      if(!this.formData.WxNickname){
        this.$message.error('请输入昵称')
        return
      }
      try {
        this.formData.MemberId = this.id;
        await setAgentCheckUserInfo(this.formData)
        this.$message({
          type: 'success',
          message: '更新成功！'
        })
        this.toBack();
      } catch (e) {
        console.log(e)
      }
    }

    // 上传成功
    private uploadSuc(list: any, type ? : string) {
      this.formData[type] = list[0]
    }

    private isPhone(tel) {
      var reg=/^1[3-9]\d{9}$/
      return reg.test(tel)
    }

    /**
     * 获取分销员列表
     */
    private async getMembers(query ? : string) {
      if (!query.length) return;
      query = query.trim()
      this.loadingProduct = true;
      let params: any = {
        page_no: 1,
        page_size: 500,
        user_type: 2,
        level: 99
      }
      if (query && this.isPhone(query)) {
        params.phone = query
      } else if (query) {
        params.keyword = query
      }
      try {
        const res: any = await getAgentUserList(params)
        this.members = res.info || []
        if ('公司'.indexOf(query) !== -1) {
          this.members.push({level: 4, name: '公司', user_id: 1, phone: ''})
        }
        this.loadingProduct = false
      } catch (e) {
        console.log(e)
        this.loadingProduct = false;
      }
    }
  }
